import { 
  TalentSurveyQuestions,
  TalentSurveyQuestionApiObject,
  TalentSurveyApiObject,
} from '../types';

export default class TalentSurveyQuestionsSerializer {
  static toObject(
    talentSurvey: TalentSurveyApiObject
  ): TalentSurveyQuestions {
    return [talentSurvey.core_items, talentSurvey.random_items].flat().flatMap(
      (coreItem: TalentSurveyQuestionApiObject) => {
        return {
          id: coreItem.resource_id,
          required: coreItem.required,
          title: coreItem.title,
          configuration: {
            minValue: coreItem.scale_configuration.min_value,
            maxValue: coreItem.scale_configuration.max_value,
            step: coreItem.scale_configuration.step,
            labelLeft: {
              en: coreItem.scale_configuration.label_left.en,
              de: coreItem.scale_configuration.label_left.de,
            },
            labelRight: {
              en: coreItem.scale_configuration.label_right.en,
              de: coreItem.scale_configuration.label_right.de,
            },
          },
        };
      }
    );
  }
}
